//　最低の休日設定日数
//  お手伝い日数から計算した日数とと移動日設定から計算した日数で、大きい方を採用する
export const calculateMinHolidays = ({
  duration,
  firstDayStatus,
  lastDayStatus,
}: {
  duration: number;
  // TODO 型定義を正確にする
  firstDayStatus: string;
  lastDayStatus: string;
}): number => {
  const WEEK_DAY = 7;
  const calculateMinHolidayFromDuration = Math.floor(duration / WEEK_DAY);
  const calculateMinHolidayFromFirstDayStatus =
    firstDayStatus === 'moving' ? 1 : 0;
  const calculateMinHolidayFromLastDayStatus =
    lastDayStatus === 'moving' ? 1 : 0;
  const calculateMinHolidayFromMovingStatus =
    calculateMinHolidayFromFirstDayStatus +
    calculateMinHolidayFromLastDayStatus;

  return calculateMinHolidayFromDuration >= calculateMinHolidayFromMovingStatus
    ? calculateMinHolidayFromDuration
    : calculateMinHolidayFromMovingStatus;
};
